"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExtendGoToParagraphEndCommand = exports.GoToParagraphEndCommand = exports.GoToParagraphEndCommandBase = void 0;
var tslib_1 = require("tslib");
var layout_box_iterator_main_sub_document_1 = require("../../../core/layout-engine/layout-box-iterator/layout-box-iterator-main-sub-document");
var layout_box_iterator_other_sub_document_1 = require("../../../core/layout-engine/layout-box-iterator/layout-box-iterator-other-sub-document");
var layout_position_creator_1 = require("../../../core/layout-engine/layout-position-creator");
var document_layout_details_level_1 = require("../../../core/layout/document-layout-details-level");
var layout_box_1 = require("../../../core/layout/main-structures/layout-boxes/layout-box");
var selection_command_base_1 = require("./selection-command-base");
var GoToParagraphEndCommandBase = (function (_super) {
    tslib_1.__extends(GoToParagraphEndCommandBase, _super);
    function GoToParagraphEndCommandBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToParagraphEndCommandBase.prototype.executeCore = function (_state, _options) {
        var selection = this.selection;
        var position = this.getPositionEndParagraph();
        if (position < 0)
            return false;
        if (this.extendSelection())
            this.selection.changeState(function (newState) { return newState.extendLastInterval(position).setEndOfLine(false); });
        else
            selection.deprecatedSetSelection(position, position, false, selection.keepX, true);
        return true;
    };
    GoToParagraphEndCommandBase.prototype.getPositionEndParagraph = function () {
        var selection = this.selection;
        var subDocument = this.selection.activeSubDocument;
        var layout = this.control.layout;
        var lastPageEndPos = subDocument.isMain() ? layout.getLastValidPage().getEndPosition() : layout.pages[selection.pageIndex].otherPageAreas[subDocument.id].getEndPosition();
        var currentPos = selection.forwardDirection ? selection.lastSelectedInterval.end : selection.lastSelectedInterval.start;
        var boxIterator = subDocument.isMain() ? new layout_box_iterator_main_sub_document_1.LayoutBoxIteratorMainSubDocument(subDocument, layout, currentPos, lastPageEndPos) :
            new layout_box_iterator_other_sub_document_1.LayoutBoxIteratorOtherSubDocument(subDocument, layout, currentPos, lastPageEndPos, this.selection.pageIndex);
        if (!boxIterator.isInitialized())
            return -1;
        while (boxIterator.moveNext(new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(false), new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(true))) {
            if (boxIterator.position.box.getType() == layout_box_1.LayoutBoxType.ParagraphMark || boxIterator.position.box.getType() == layout_box_1.LayoutBoxType.SectionMark) {
                boxIterator.moveNext(new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(false), new layout_position_creator_1.LayoutPositionCreatorConflictFlags().setDefault(true));
                if (boxIterator.position.getLogPosition() == lastPageEndPos)
                    return boxIterator.position.getLogPosition(document_layout_details_level_1.DocumentLayoutDetailsLevel.Box);
                return boxIterator.position.getLogPosition();
            }
        }
        if (boxIterator.position.box.getType() == layout_box_1.LayoutBoxType.ParagraphMark || boxIterator.position.box.getType() == layout_box_1.LayoutBoxType.SectionMark)
            return boxIterator.position.getLogPosition(document_layout_details_level_1.DocumentLayoutDetailsLevel.Box);
        return boxIterator.position.getLogPosition();
    };
    return GoToParagraphEndCommandBase;
}(selection_command_base_1.SelectionCommandBase));
exports.GoToParagraphEndCommandBase = GoToParagraphEndCommandBase;
var GoToParagraphEndCommand = (function (_super) {
    tslib_1.__extends(GoToParagraphEndCommand, _super);
    function GoToParagraphEndCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GoToParagraphEndCommand.prototype.extendSelection = function () {
        return false;
    };
    return GoToParagraphEndCommand;
}(GoToParagraphEndCommandBase));
exports.GoToParagraphEndCommand = GoToParagraphEndCommand;
var ExtendGoToParagraphEndCommand = (function (_super) {
    tslib_1.__extends(ExtendGoToParagraphEndCommand, _super);
    function ExtendGoToParagraphEndCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ExtendGoToParagraphEndCommand.prototype.extendSelection = function () {
        return true;
    };
    return ExtendGoToParagraphEndCommand;
}(GoToParagraphEndCommandBase));
exports.ExtendGoToParagraphEndCommand = ExtendGoToParagraphEndCommand;
